<template>
       <div>

       </div>

</template>

<script>
// import { sayHello } from '../../output'
// import * as grpcWeb from 'grpc-web'
// const {EchoServiceClient} = require('./output.js')
// const client = new EchoServiceClient('localhost:8080')
// const { PingPongServiceClient } = require('../ping_pong_grpc_web_pb')
// const { PingRequest } = require('../ping_pong_pb.js')
// var client = new PingPongServiceClient('http://localhost:9999')
export default {
  data: () => ({
  }),
  created () {
    const request = new PingRequest()
    console.log(request)
    request.setPing('123')
    request.setPong('456')
    request.setMomo('789')

    console.log(request.getPong())
    // request.setPong('Pong')
    // client.pingPong(request, {}, (err, response) => {
    //   if (response == null) {
    //     console.log(err)
    //   } else {
    //     // console.log(response.getPong())
    //     // response.setPong('Pong23')
    //     console.log(response.getPong())
    //     console.log(response)
    //   }
    // })

    client.pingPong2(request, {}, (err, response) => {
      console.log(request)
      if (response == null) {
        console.log(err)
      } else {
        console.log(response.toObject())
        console.log(response)
      }
    })
    client.pingPong(request, {}, (err, response) => {
      if (response == null) {
        console.log(err)
      } else {
        // console.log(response.getPong())
        response.setPong('Pong26')
        console.log(response.getPong())
        // console.log(response)
      }
    })

    client.pingPong(request, {}, (err, response) => {
      if (response == null) {
        console.log(err)
      } else {
        console.log(response.getPong())
        // console.log(response)
      }
    })
    // sayHello({
    //   name: 'foobar',
    //   age: '99',
    //   children: ['john', 'mike']
    // }).then((res) => console.log(res))
    // console.log(client)
    // client.sayHello({name: 'foobar', age: '99', children: ['john', 'mike']}, (err, response) => {
    //   console.log(err)
    // })
  },
  watch: {
  },
  methods: {
  },
  computed: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/test.vue